{
  "INBOX": {
    "LIST": {
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Display",
      "LOADING": "Fetching notifications",
      "404": "There are no active notifications in this group.",
      "NO_NOTIFICATIONS": "No notifications",
      "NOTE": "Notifications from all subscribed inboxes",
      "NO_MESSAGES_AVAILABLE": "Oops! Not able to fetch messages",
      "SNOOZED_UNTIL": "Snoozad till",
      "SNOOZED_UNTIL_TOMORROW": "Snoozad till imorgon",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozad till nästa vecka"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Snooze notification",
      "DELETE": "Delete notification",
      "BACK": "Tillbaka"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "You have been mentioned in a conversation",
      "CONVERSATION_CREATION": "New conversation created",
      "CONVERSATION_ASSIGNMENT": "A conversation has been assigned to you",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "New message in an assigned conversation",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "New message in a conversation you are participating in",
      "SLA_MISSED_FIRST_RESPONSE": "SLA target first response missed for conversation",
      "SLA_MISSED_NEXT_RESPONSE": "SLA target next response missed for conversation",
      "SLA_MISSED_RESOLUTION": "SLA target resolution missed for conversation"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nytt meddelande",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nytt meddelande",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nytt meddelande"
    },
    "NO_CONTENT": "Inget innehåll tillgängligt",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Utgående samtal - Anslutet",
      "OUTBOUND_FAILED": "Utgående samtal - Misslyckades",
      "INBOUND_MISSED": "Inkommande samtal - Missat",
      "INBOUND_UNANSWERED_MISSED": "Inkommande samtal - Missat, obesvarat",
      "INBOUND_AGENT": "Inkommande samtal - Besvarat av agent",
      "INBOUND_IVR": "Inkommande samtal - Besvarat av IVR",
      "DEFAULT": "Telefonsamtal"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Mark as read",
      "MARK_AS_UNREAD": "Markera som oläst",
      "SNOOZE": "Snooza",
      "DELETE": "Radera",
      "MARK_ALL_READ": "Markera alla som lästa",
      "DELETE_ALL": "Delete all",
      "DELETE_ALL_READ": "Delete all read"
    },
    "DISPLAY_MENU": {
      "SORT": "Sort",
      "DISPLAY": "Display :",
      "SORT_OPTIONS": {
        "NEWEST": "Newest",
        "OLDEST": "Oldest",
        "PRIORITY": "Prioritet"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Pausad",
        "READ": "Read",
        "LABELS": "Etiketter",
        "CONVERSATION_ID": "Conversation ID"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notification marked as read",
      "MARK_AS_UNREAD": "Notification marked as unread",
      "SNOOZE": "Notification snoozed",
      "DELETE": "Notification deleted",
      "MARK_ALL_READ": "All notifications marked as read",
      "DELETE_ALL": "All notifications deleted",
      "DELETE_ALL_READ": "All read notifications deleted"
    }
  }
}
